import { getAuthToken } from './api/client';

export const DEPLOYMENTS_API_URL = (
  process.env.REACT_APP_CLAUDE_API_URL || 'https://claude.owazamartialarts.com'
).replace(/\/$/, '');

const request = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    throw new Error('Admin authentication required');
  }

  const response = await fetch(`${DEPLOYMENTS_API_URL}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const detail = typeof data.detail === 'string' ? data.detail : null;
    throw new Error(detail || `Deployment request failed (${response.status})`);
  }

  return data;
};

export const listDeployments = (limit = 20, { signal } = {}) => request(
  `/api/deployments?limit=${encodeURIComponent(limit)}`,
  signal ? { signal } : {},
);

export const getDeployment = (deploymentId) => request(
  `/api/deployments/${encodeURIComponent(deploymentId)}`,
);

export const listActiveRemediations = () => request('/api/remediations/active');

export const cancelRemediation = (remediationId, body) => request(
  `/api/remediation/${encodeURIComponent(remediationId)}/cancel`,
  {
    method: 'POST',
    body: JSON.stringify(body),
  },
);

export const respondToDeployment = (deploymentId, responses) => request(
  `/api/deployments/${encodeURIComponent(deploymentId)}/respond`,
  {
    method: 'POST',
    body: JSON.stringify({ responses }),
  },
);

export const declineDeploymentRemediation = (deploymentId) => request(
  `/api/deployments/${encodeURIComponent(deploymentId)}/decline-remediation`,
  { method: 'POST' },
);

export const triggerDeployment = (target) => request('/api/deploy', {
  method: 'POST',
  body: JSON.stringify({ target }),
});
